export const BASE_URL = '//edubook.vicensvives.'

export const WHITE_SPACE = ' '
export const SUCCESS = 'success'
export const ERROR = 'error'
export const DEFAULT = 'default'

export const TYPES_ALERTS = {
  ERROR: ERROR,
  INFO: 'info',
  SUCCESS: SUCCESS,
  WARNING: 'warning',
}

export const TYPES_HEADER = {
  CUSTOM_HEADER: 'customHeader',
  DEFAULT: 'default',
  DOUBLE_HEADER: 'doubleHeader',
  USER_PROFILE: 'userProfile',
}

export const TYPES_FETCH_STATUS = {
  FETCHING: 'fetching',
  IDLE: 'idle',
  PAUSED: 'paused',
}

export const TYPES_CHECKBOX = {
  CHECKED: 'checked',
  EMPTY: 'empty',
  INDETERMINATE: 'indeterminate',
}

export const PROCESS_STATUS = {
  FINISHED: 'FINISHED',
  IN_PROGRESS: 'IN_PROGRESS',
  NON_INITIATED: 'NON_INITIATED',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
}

// Authorization Google required by the API;
export const TYPE_VLE = {
  GOOGLE: 'GOOGLE_CLASSROOM',
}

export const SCOPES =
  'https://www.googleapis.com/auth/classroom.rosters.readonly \
   https://www.googleapis.com/auth/classroom.coursework.students \
   https://www.googleapis.com/auth/classroom.announcements \
   https://www.googleapis.com/auth/classroom.courses.readonly \
   https://www.googleapis.com/auth/classroom.coursework.students.readonly'

export const DASH_STRING = '-'
export const UNDERSCORE_STRING = '_'
export const EMPTY_STRING = ''

export const TYPES_LICENSE = {
  BASIC: 'BASIC',
  PREMIUM: 'PREMIUM',
}

export const TYPES_DEVICES = { ANDROID: 'android', IOS: 'iOS' }
export const SECTIONS = {
  ASSESSMENT: 'evaluations',
  BOOKS: 'books',
  CATALOGUE: 'catalogue',
  CLASSROOM: 'classroom',
  HOME: 'home',
  STUDENTS: 'students',
}

export const NAVIGATION_TYPES = {
  BOTTOM: 'bottom',
  MENU: 'menu',
  RAIL: 'rail',
}

export const TYPE_ICON_PASSWORD = {
  HIDE: 'hide',
  SHOW: 'show',
}

export const SIZE_TABLE = 35
export const INITIAL_PAGE_TABLE = 0
export const NEXT_PAGE = 'next'
export const ALL_OPTION_KEY = 'ALL'
